import React from 'react';
import Icon from '../../../components/AppIcon';
import UserAvatar from '../../../components/UserAvatar';

const LeaderboardPanel = ({ currentUser, topUsers }) => {
  const getMedalIcon = (position) => {
    if (position === 1) return { name: 'Medal', color: 'var(--color-secondary)' };
    if (position === 2) return { name: 'Medal', color: '#C0C0C0' };
    if (position === 3) return { name: 'Medal', color: '#CD7F32' };
    return null;
  };

  return (
    <div className="bg-card rounded-xl shadow-md p-6">
      <h2 className="text-2xl font-semibold text-card-foreground mb-4 flex items-center gap-2">
        <Icon name="TrendingUp" size={24} color="var(--color-accent)" />
        XP Leaderboard
      </h2>
      <div className="bg-gradient-to-r from-primary/10 to-secondary/10 rounded-lg p-4 mb-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center text-primary-foreground font-bold text-lg">
              #{currentUser?.rank}
            </div>
            <div>
              <p className="font-semibold text-card-foreground">Your Rank</p>
              <p className="text-sm text-muted-foreground">{currentUser?.name}</p>
            </div>
          </div>
          <div className="text-right">
            <p className="text-2xl font-bold text-primary">{currentUser?.xp?.toLocaleString()}</p>
            <p className="text-xs text-muted-foreground">Total XP</p>
          </div>
        </div>
      </div>
      <div className="space-y-2">
        {topUsers?.map((user, index) => {
          const medal = getMedalIcon(index + 1);
          return (
            <div 
              key={user?.id}
              className={`flex items-center justify-between p-3 rounded-lg transition-colors duration-150 ${
                user?.id === currentUser?.id ? 'bg-primary/10 border border-primary' : 'bg-muted/50 hover:bg-muted'
              }`}
            >
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center font-bold text-muted-foreground">
                  {medal ? (
                    <Icon name={medal?.name} size={24} color={medal?.color} />
                  ) : (
                    <span>#{index + 1}</span>
                  )}
                </div>
                <UserAvatar userId={user?.id} name={user?.name} size="w-8 h-8" textSize="text-xs" />
                <div>
                  <p className="font-medium text-card-foreground">{user?.name}</p>
                  <p className="text-xs text-muted-foreground">{user?.playsCompleted} plays completed</p>
                </div>
              </div>
              <div className="text-right">
                <p className="font-bold text-card-foreground">{user?.xp?.toLocaleString()}</p>
                <p className="text-xs text-muted-foreground">XP</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LeaderboardPanel;